import { getLogger } from '@logtape/logtape';
import { AxiosResponse } from 'axios';
import { FC, useEffect, useState } from 'react';

import { Page } from '@/components/Page.tsx';

import { api } from '@/lib/api-client.ts';

import LoadingPage from '@/pages/LoadingPage.tsx';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { attachLocaleToUrl } from '@/utils/urlUtils.ts';

const logger = getLogger(['page', 'careview']);

interface ApiResponse {
    embed_url: string;
}

const CareviewPage: FC = () => {
    const [is_loading, setIsLoading] = useState(true);
    const [embed_url, setEmbedUrl] = useState<string | undefined>(undefined);

    const getCareviewEmbedUrl = async (): Promise<boolean> => {
        try {
            const response: AxiosResponse<ApiResponse> = await api.get(ServiceUrl.BI_API_DOMAIN.CAREVIEW_DASHBOARDS);

            const url: string | undefined = response.data.embed_url;

            if (!url) {
                setEmbedUrl(undefined);
                setIsLoading(false);
                return false;
            }

            const url_with_locale: string = attachLocaleToUrl(url);
            setEmbedUrl(url_with_locale);
            setIsLoading(false);
            return true;
        } catch (error) {
            logger.error('Failed to fetch careview embed URL', { error: error });
            setEmbedUrl(undefined);
            setIsLoading(false);
            return false;
        }
    };

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        void getCareviewEmbedUrl();
    }, []);

    if (is_loading) {
        return <LoadingPage />;
    }

    return (
        <Page className="flex flex-col px-5">
            {!embed_url && <div>Keine Daten verfügbar</div>}
            {embed_url && (
                <iframe title="quicksight-iframe" className="h-[120%] w-full" id="quicksight-iframe" src={embed_url} />
            )}
        </Page>
    );
};

export default CareviewPage;
